import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Some products may be covered by WIC. If a product is covered by WIC, authorizations can be obtained through Medicaid prior to members enrolling with WIC. Please check if the formula being ordered is covered by WIC and assist the member’s family in contacting the local WIC office. Medicaid does not reimburse for standard milk-based infant formulas..  </p>

				<div className="button" onClick={() => this.props.navigate('R31A')}>To request a prior authorization on a different member, click here. </div>
			</div>
		);
	}
}